import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsLogged, setToken, setData } from "@pages/auth/Actions";
export function Guard() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);

  if (!profile.isloged) {
    window.location = "/login";
  }

  /**
   * verification si la session est toujours en cours
   */

  if (profile?.logged_at) {
    const diffTime = Math.floor(
      (Date.now() - new Date(profile?.logged_at).getTime()) / 60000
    );

    /*if (diffTime > 60) {
      dispatch(setIsLogged(false));
      dispatch(setToken(""));
      dispatch(setData([]));
      localStorage.removeItem("authToken");
      ////ouvrirr la connextion vers iws
      return <Navigate to="/login" replace />;
    }*/
  }
  localStorage.setItem("authToken", profile.token);

  return profile;
}
